import { useState, useEffect } from "react";
import * as Scrivito from "scrivito";
import moment from "moment";

export const LdapSyncMessages = Scrivito.connect(() => {
  const [pages, setPages] = useState([]);
  const [isHidden, setIsHidden] = useState(false);
  useEffect(() => {
    const fetchDeactivatedContactPages = async () => {
      const fetchedPages = await Scrivito.load(() =>
        Scrivito.Obj.onAllSites()
          .where("_objClass", "equals", "ContactPage")
          .and("isDeactivated", "equals", true)
          .and(
            "lastDeactivationDate",
            "isGreaterThan",
            moment().startOf("day").add(-3, "days").toDate()
          )
          .toArray()
          .map((page) => ({
            id: page.id(),
            lastDeactivationDate: page.get("lastDeactivationDate"),
            title: page.get("title"),
          }))
      );
      setPages(fetchedPages);
    };
    fetchDeactivatedContactPages();
  }, []);

  if (pages.length === 0 || isHidden || !Scrivito.isInPlaceEditingActive()) {
    return null;
  }

  return (
    <div className="page-hints__contact-pages">
      LDAP System has deactivated foollowing of Contact Pages:
      {pages.map((page) => (
        <div key={page.id}>
          <b>{`id: ${page.id}, title: ${page.title}`}</b>
        </div>
      ))}
      <div className="py-3">
        if they shouldn&apos;t be deactivated please contact your Administrator
        or IT support
      </div>
      <button className="btn bg-white" onClick={() => setIsHidden(true)}>
        Hide
      </button>
    </div>
  );
});
